import { useEffect, useRef, useState } from 'react'
import { ChevronDown, Check } from 'lucide-react'
import { useCurrency } from '../contexts/CurrencyContext'

// Header currency switcher. Display-only: USD is native, the rest are
// approximate conversions (checkout is still charged in USD).
export default function CurrencySelector() {
  const { currency, currencies, setCurrencyCode } = useCurrency()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return
    const onDown = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', onDown)
    document.addEventListener('keydown', onKey)
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey) }
  }, [open])

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-label="Change currency"
        aria-expanded={open}
        className="inline-flex items-center gap-1 h-10 px-3 rounded-full text-[13px] font-medium text-[#b9bbc1] hover:text-white hover:bg-white/[0.08] transition-colors"
      >
        <span className="tabular-nums">{currency.code}</span>
        <ChevronDown className={'w-3.5 h-3.5 transition-transform ' + (open ? 'rotate-180' : '')} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 z-50 mw-glass rounded-[20px] p-1.5 shadow-2xl mw-fade">
          {currencies.map((c) => {
            const on = c.code === currency.code
            return (
              <button
                key={c.code}
                onClick={() => { setCurrencyCode(c.code); setOpen(false) }}
                className={'w-full flex items-center justify-between gap-2 px-3.5 py-2.5 rounded-[14px] text-left transition-colors ' + (on ? 'bg-white/[0.07]' : 'hover:bg-white/[0.05]')}
              >
                <span className="flex items-baseline gap-3">
                  <span className={'text-[14px] ' + (on ? 'text-white' : 'text-[#a6a8ae]')}>{c.code}</span>
                  <span className={'text-[11px] ' + (c.note === 'NATIVE' ? 'text-[#34d399]' : 'text-[#5d6068]')}>{c.note === 'NATIVE' ? 'Native' : 'Approx'}</span>
                </span>
                {on && <Check className="w-4 h-4 text-white shrink-0" />}
              </button>
            )
          })}
          <p className="px-3.5 pt-2.5 pb-2 text-[11px] leading-snug text-[#5d6068]">Approximate currencies are estimates - you're charged in USD at checkout.</p>
        </div>
      )}
    </div>
  )
}
